import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepContent from '@material-ui/core/StepContent';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';

import Add from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/icons/Menu';
import Grid from '@material-ui/core/Grid';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faEnvelope, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons'
import { COLORS } from '../../styles/colors';

import StepMessage from './StepMessage'


export const isSet = (value) => {
  return value !== undefined && value !== null;
}

export const stepOptions = [
  {label: 'Message', value: ''},
  {label: 'Wait For', value: ''},
];


class DynamicStepper extends React.Component {
  constructor(props){
      super(props);
      this.state = {
          steps: props.isReadOnly ? [] : [ 
            {
              message: '', 
              timeGap: 'day(s)',
              isWait: false,
              isStartTrigger: true,
              formatMessage: 'Click + icon to add first message'
            },
          ],
          activeStep: 0
      }
      
  }

  changeStepValue(ind, value){
    let steps = [...this.state.steps];
    steps[ind].value = value;
    const option = stepOptions.find((item) => item.value === value);
    steps[ind].title = option ? option.label : 'Undefined';
    this.setState({steps: steps, activeStep: steps.length});
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
		if (this.props.automationSteps !== nextProps.automationSteps) {
      if(this.props.editId) {
        let automationSteps = nextProps.automationSteps;
        if(nextProps.isReadOnly) {
          automationSteps = automationSteps.filter((s) => !s.isStartTrigger )
        }
        this.setState({
          steps: automationSteps
        })
      }
		}
	}

  getSaveSteps() {
    let newSteps = [...this.state.steps];
    return newSteps.filter((s) => s.isSaved );
  }

  addStep(n = 1){
    let newSteps = [...this.state.steps];
    const savedSteps = this.getSaveSteps();
    if(savedSteps.length === newSteps.length - 1) {
      for(let i = 0; i < n; i++){
        const stepLength = newSteps.length + 1;
        newSteps.push({
          message: '', 
          timeGap: '',
          frequncyGap: 'day(s)',
          isWait: stepLength % 2 !== 0 ? true : false,
          isSaved: false
        });
      }
      this.setState({steps: newSteps, activeStep: newSteps.length -1});
    }
  }

  removeStep(ind){
    let steps = [...this.state.steps];
    if(steps.length < ind + 1){return;}
    steps = steps.filter((item, i) => i !== ind);
    this.setState({steps: steps, activeStep: steps.length});
  }

  onSaveStep(data, stepIndex)  {
    const updateList = [...this.state.steps];
    const list = updateList[stepIndex];
    let formatMessage = ''
    if(!list.isWait) {
      formatMessage = data.message;
    } else {
      formatMessage =  `Wait ${data.timeGap} ${data.frequncyGap}`
    }
    updateList[stepIndex] = {
        ...updateList[stepIndex],
        ...data,
        isSaved: true,
        formatMessage: formatMessage
    }
    this.setState({
      steps: updateList,
      activeStep: 0
    })
  }

  onDeleteStep(evt, stepIndex) {
    let updateList = [...this.state.steps];
    let arr = [stepIndex];
    const nextStep = stepIndex + 1;
    const nextList = updateList[nextStep];
    if (nextList && nextList.isWait) {
      arr.push(nextStep)
    }
    let newSteps = []
    for(let i = 0; i < updateList.length; i++) {
        if(!arr.includes(i)) {
          newSteps.push(updateList[i])
        }
    }
    this.setState({
      activeStep: 0
    }, () => {
      this.setState({
        steps: newSteps
      })
    })
  }

  
  render() {
    const { classes } = this.props;
    const { activeStep, steps } = this.state;
    const savedSteps = this.getSaveSteps();
   
    return (
      <React.Fragment>
        <div className={classes.body}>
          <Stepper nonLinear activeStep={activeStep} orientation="vertical">
            {steps.map((step, index) => (
              <Step key={`step_${index}_container`} >
                {
                  step.isStartTrigger ?
                    <div style={{display: 'flex'}}>
                      <Typography>{step.formatMessage}</Typography>
                    </div>
                : step.isSaved ?
                      <Fragment>
                      <div style={{ 
                           width: '250px'
                          }}>
                        <Box 
                          bgcolor={ step.isWait ? COLORS.white : "#65758a" }
                          borderRadius="borderRadius"
                          title={this.props.isReadOnly && step.formatMessage}
                          width={200} 
                          height={75}
                          style={{ 
                            marginLeft: 0, 
                            padding: '15px',
                            borderColor: '#edf0f7',
                            border: 'solid 1px'
                          }}
                          onClick={() => {
                            if(!this.props.isReadOnly) {
                                this.setState({
                                activeStep: !steps[activeStep]['isSaved'] ?  activeStep : index
                              }) 
                            }}}
                        >   <div style={{
                              margin: 'auto',
                              width: '180px',
                              padding: '10px',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              color: `${ !step.isWait ? COLORS.white : COLORS.black }`,
                              overflow: 'hidden' 
                              }}>
                              { step.isWait ? 
                                <Fragment>
                                <FontAwesomeIcon 
                                    size="lg"
                                    icon={faClock}
                                    style={{ marginRight: 5, color: COLORS.black }}
                                /> {step.formatMessage}
                                </Fragment>
                                :
                                <Fragment>
                                <FontAwesomeIcon 
                                    size="lg"
                                    icon={faEnvelope}
                                    style={{ marginRight: 5, color: COLORS.white }}
                                /> {step.formatMessage}
                                </Fragment>
                              }
                          </div>
                        </Box>
                       
                          <Fragment>
                            { !this.props.isReadOnly &&
                              <IconButton 
                                color="primary" 
                                onClick={() => {
                                  let newSteps = [...this.state.steps];
                                    newSteps = newSteps.filter((s) => {
                                    return s.isSaved || s.isStartTrigger
                                    });
                                    this.setState({
                                      activeStep:  index,
                                      steps: newSteps
                                    })
                                }}
                                disableFocusRipple
                                disableRipple
                                className={classes.disableRipple}
                                style={{ 
                                  float: 'right',
                                  marginTop: '-60px',
                                  marginRight: '10px'
                                  }}
                                component="span">
                                <FontAwesomeIcon 
                                      size="32"
                                      icon={faEdit}
                                      style={{ color: COLORS.orange }}
                                  />
                              </IconButton>
                            }
                            {
                              (!step.isWait && !this.props.isReadOnly) &&
                            <IconButton 
                               color="primary" 
                               onClick={(event) => this.onDeleteStep(event, index)}
                               disableFocusRipple
                               disableRipple
                               className={classes.disableRipple}
                               style={{ 
                                float: 'right',
                                marginTop: '-60px',
                                marginRight: '-12px'
                                }}
                               component="span">
                              <FontAwesomeIcon 
                                    size="32"
                                    icon={faTrash}
                                    style={{ color: COLORS.orange }}
                                />
                            </IconButton>
                          }

                            
                          </Fragment>
                        
                      </div>

                      </Fragment>
                    : <div style={{display: 'flex', marginLeft: '40px'}}>
                        <Typography>
                          { !step.isWait ? 'Enter message below' : 'Enter the amount of time you want to wait before sending the next message'}
                        </Typography>
                      </div>
                }
                 <StepContent>
                  { (index !== 0 && index % 2 !== 0) &&
                     <StepMessage 
                        stepIndex={index} 
                        isWait = {false}
                        onSave={(data, stepIndex) => this.onSaveStep(data, stepIndex)} 
                        data = {step}>
                      </StepMessage>
                  }
                  { (index !== 0 && index % 2 === 0) &&
                     <StepMessage 
                        stepIndex={index} 
                        isWait = { true }
                        onSave={(data, stepIndex) => this.onSaveStep(data, stepIndex)} 
                        data = {step}>
                     </StepMessage>
                  }
                </StepContent>
              </Step>
            ))}
            { !this.props.isReadOnly &&
            <Step key={'add-a-step'} >
              <StepButton
                onClick={() => this.addStep()}
                icon={
                <Add 
                className={(steps.length > 0 && steps.length -1 !== savedSteps.length) ? classes.addButton : classes.addDisButton}/>}
                style={{fontWeight: 'bold'}}
              >
              </StepButton>
            </Step>
            }
          </Stepper>
        </div>
      </React.Fragment>
    );
  }
}

DynamicStepper.propTypes = {
  classes: PropTypes.object,
};

const styles = theme => ({
  addButton:{
    color: COLORS.lightGrey, 
    transformOrigin: 'center', 
    transform: 'scale(1.3)',
  },
  addDisButton: {
    color: COLORS.orange, 
    transformOrigin: 'center', 
    transform: 'scale(1.3)',
  },
  body:{
    marginTop: theme.spacing.unit * 1,
    [theme.breakpoints.down('xs')]:{
      marginTop: theme.spacing.unit * 1
    },
    "& .MuiStepper-root": {
      padding: "5px !important",
    },
    "& .MuiStepConnector-vertical": {
      marginLeft: '100px'
    },
    "& .MuiStepContent-root": {
      marginLeft: '100px'
    },
    "& .MuiStepButton-vertical": {
      marginLeft: '72px'
    }
    
  },
  stepButtons: {
    "& .MuiStepButton-root": {
      width: "20px !important",
    }
  },
  disableRipple: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export default withStyles(styles)(DynamicStepper);


// WEBPACK FOOTER //
// ./src/components/automations/DynamicStepper.js